var _defs, _circle, _path, _g, _path2, _circle2, _circle3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoCircle1Pt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 660.48 587.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#95c11f;}.cls-2,.cls-3{fill:#1f2419;}.cls-2{clip-path:url(#clip-path);}.cls-4{clip-path:url(#clip-path-2);}.cls-5{fill:#f1f1ee;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 331.17,
    cy: 292.9,
    r: 285.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M331.17,585.81a292.9,292.9,0,0,1-207.11-500A292.9,292.9,0,1,1,538.29,500,291,291,0,0,1,331.17,585.81Zm0-570.81a277.9,277.9,0,0,0-196.5,474.41,277.9,277.9,0,1,0,393-393A276.09,276.09,0,0,0,331.17,15Z"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 331.17,
    cy: 292.9,
    r: 285.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M331.17,585.81a292.9,292.9,0,0,1-207.11-500A292.9,292.9,0,1,1,538.29,500,291,291,0,0,1,331.17,585.81Zm0-570.81a277.9,277.9,0,0,0-196.5,474.41,277.9,277.9,0,1,0,393-393A276.09,276.09,0,0,0,331.17,15Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    y: 292.84,
    width: 660.48,
    height: 331.09
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M45.77,291.07c0,157.63,127.78,285.41,285.4,285.41S616.58,448.7,616.58,291.07V291H45.77Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 331.17,
    cy: 292.9,
    r: 147.57
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 331.17,
    cy: 292.9,
    r: 125.91
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M356.82,169.61A126,126,0,0,1,455.66,274H383.34v-1.4A30.35,30.35,0,0,0,353,242.27h0a30.35,30.35,0,0,0-30.34,30.35v37.11A30.34,30.34,0,0,0,353,340.07h0a30.33,30.33,0,0,0,30.27-28.28h72.4A126,126,0,0,1,358,415.93c-37.6-11.72-65.88-62.49-65.88-123.35C292.13,232.36,319.82,182,356.82,169.61Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M155.54,361l-12-25.07,17.65-8.49L198,404.15l-17.65,8.48-12.05-25.07-56.57,27.2L99,388.2Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M174.77,482.83Q169,470.62,178,455.71l26.23-43.09,25.17,15.32-24.74,40.64q-4.29,7-3.05,12.11t8.9,9.73q7.71,4.69,12.76,3.48t9.37-8.29L257.41,445l25.17,15.31-26.23,43.1q-9.08,14.89-22.59,15.35t-33.37-11.64Q180.59,495,174.77,482.83Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M292,462.25l58.91-1.54q15.48-.4,21.9,7t6.73,19.2q.3,11.64-6.09,18.92t-22.62,7.7l-27.93.73.77,29.58-29.51.77Zm50.37,33.64c2.93-.07,5-.73,6.08-2s1.66-3.2,1.59-5.84-.71-4.63-1.92-5.84-3.27-1.78-6.15-1.7l-19.94.52.4,15.37Zm-14.69,9.73L357,504.11l26.32,38.12-32.38.85Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M379.47,461.08l25.27-15.73,47.81,43.1.15-.1L435,426.52l25.32-15.76,19.59,84.81L447,516.07Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M529,434.44q-14.82,4.9-32.62-4.12t-22.69-23.84q-4.79-14.76,6.87-37.78T507,340.78q14.76-4.9,32.66,4.17t22.63,23.84q4.83,14.83-6.84,37.84T529,434.44Zm11.75-50.32q-1-6.17-14.4-12.94-13.65-6.93-19.09-4T498,377.55q-3.78,7.45-2.9,13.54t14.54,13q13.4,6.78,18.95,4T538,397.78Q541.77,390.28,540.75,384.12Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M149.76,272.77q-11.67,3.78-32.19-1.69T88.86,256.5q-8.16-9.09-3.13-27.89,5.1-19.1,16-22.43t24.95.42l-4.36,16.32q-13-3.48-18.3-1t-7.2,9.69q-1.92,7.2,1.77,12.53t23.31,10.59q19.62,5.24,25.55,2.46c3.94-1.85,6.56-5.17,7.83-10s.78-8.75-1.47-12-7.66-6-16.22-8.28L142,210.67q13.61,3.65,21.59,12.05t2.93,27.34Q161.45,269,149.76,272.77Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M119.65,153.31l14.22-19.46,80.26,29.94L204,177.68l-20.37-8.31-15,20.54,14.07,16.93-10.15,13.89Zm53.54,11.31L135,149.48l-.11.15L161,181.36Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M174.72,91.75,209.34,71q10.77-6.48,17.72-2.07a37.72,37.72,0,0,1,12,12.77,33.67,33.67,0,0,1,5.22,16.15q.27,8-10.7,14.54l-19.82,11.9,17.7,29.49-14.33,8.6ZM223.92,106c3-1.78,4.37-4,4.21-6.62a20.7,20.7,0,0,0-3.31-9.07c-2.08-3.45-4.24-5.86-6.51-7.23s-4.87-1.17-7.8.59L195,93l13.41,22.33Zm-1.79,8.4,13.6-9.23,34,25.53-15.33,9.2Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M262.34,46.59l48-6.12q16.77-2.13,21,4.25a28.34,28.34,0,0,1,4,25.1q-1.87,6.08-10,7.3,8.16-.6,12.42,4.78A26.48,26.48,0,0,1,343,95.22a40.12,40.12,0,0,1-1.12,17q-2.34,7.52-19.7,9.73l-49.44,6.3ZM306.9,71.53c1.81-.23,2.87-.93,3.18-2.09a13.65,13.65,0,0,0,.05-4.9,10.29,10.29,0,0,0-1.25-4.27c-.58-.82-1.74-1.13-3.47-.91l-14.22,1.82,1.55,12.16Zm5.83,33.27c2.14-.28,3.35-1,3.62-2.28a22.09,22.09,0,0,0-.19-6.52,24.55,24.55,0,0,0-1.53-6.7q-.93-2-4.14-1.62l-15.67,2L297,106.8Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M354.86,110.46Q351.08,97.62,357,78.89t16.41-27.22q10.44-8.37,33.77-1T434.3,70.94q3.78,12.91-2.15,31.7t-16.42,27.05q-10.5,8.33-33.82,1T354.86,110.46Zm42.4,2.77q4.17-1.82,9.47-18.63,5.46-17.26,3-21t-8.11-5.5q-5.6-1.77-9.69-.12t-9.56,18.92q-5.31,16.81-2.95,20.69t7.94,5.64Q393.11,115.05,397.26,113.23Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M480.38,83.55,510,113.81l-30.77,57.34.13.13,44.59-43.22,18.65,19.05-58.85,57.61-29.4-30,31.38-58.63-.25-.26-45.34,44.37-18.6-19Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M495.47,210.16q8.47-10.35,27.28-16t31.73-1.79q12.81,3.93,19.86,27.34t-1.47,33.83q-8.54,10.39-27.39,16.08t-31.61,1.68q-12.8-4-19.84-27.4T495.47,210.16Zm21.59,36.6q3.86,2.42,20.73-2.67,17.36-5.24,19.05-9.31t0-9.8q-1.7-5.61-5.36-8.07t-21,2.76q-16.87,5.09-18.76,9.22t-.19,9.74Q513.21,244.35,517.06,246.76Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCircle1Pt);
export default __webpack_public_path__ + "static/media/LogoCircle1_PT.e05b2e5574d255edf14c36dd06027ed9.svg";
export { ForwardRef as ReactComponent };